import { useMutation } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { generateRecoveryCode } from '../../../common/api/clients/mfa.api';
import { translate } from '../../../common/helpers/translate.helper';

export const useRecoveryCodeGenerate = () => {
    const { addErrorToast } = useToasts();

    return useMutation({
        mutationFn: () => generateRecoveryCode(),
        onError: () => {
            addErrorToast(translate('mfa.error.recoveryCodeFailed'));
        },
    });
};
